import React, { useEffect } from "react";
import { FileText, ArrowLeft } from "lucide-react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Career } from "../sections/Career";
import { CaseStudies } from "../sections/CaseStudies";
import { Contact } from "../sections/Contact";
import { Reveal, Overline } from "../components/site/Reveal";

export default function CareerPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="career-page">
      <Navbar />
      {/* Page intro */}
      <section className="emerald-radial relative overflow-hidden pt-36 pb-16 text-off-white sm:pt-44 sm:pb-20">
        <div className="grain absolute inset-0" />
        <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
          <Reveal>
            <a href="/" className="mb-6 inline-flex items-center gap-2 text-sm text-off-white/60 transition-colors hover:text-gold" data-testid="career-back-home">
              <ArrowLeft size={16} /> Back to OnwardTranscends
            </a>
          </Reveal>
          <Reveal><Overline dark>Career Coaching & Professional Development</Overline></Reveal>
          <Reveal delay={0.05}>
            <h1 className="mt-6 max-w-4xl font-serif text-4xl font-light leading-[1.05] sm:text-6xl">
              Take your career <span className="text-gradient-gold">beyond the next step</span>.
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-off-white/75 sm:text-lg">
              Practical, one-to-one coaching for professionals seeking progression, career change, leadership
              opportunities or greater clarity about their direction.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <button onClick={() => document.querySelector("#case-studies")?.scrollIntoView({ behavior: "smooth" })} data-testid="view-full-cv-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-4 text-sm font-semibold text-emerald-darkest transition-transform duration-300 hover:-translate-y-1">
              <FileText size={18} /> View Anthony's Full CV
            </button>
          </Reveal>
        </div>
      </section>

      <Career />
      <CaseStudies />
      <Contact />
      <Footer />
    </div>
  );
}
